import request from '@/libs/request'

// 平台用户列表
export function booklist (data) {
  return request({
    url: `book/list`,
    method: 'get',
    params: data
  })
}
export function bookInfo (id) {
  return request({
    url: `book/info/${id}`,
    method: 'get'
  })
}
// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `book/changeStatus/${id}`,
    method: 'post'
  })
}
export function getCate () {
  return request({
    url: `book/getCate`,
    method: 'get'
  })
}
export function addBooks (data) {
  return request({
    url: `book/info`,
    method: 'post',
    data
  })
}
export function delBook (id) {
  return request({
    url: `book/list/${id}`,
    method: 'delete'
  })
}
export function detailList (data) {
  return request({
    url: `bookDetail/list`,
    method: 'get',
    params: data
  })
}
export function detailEdits (data) {
  return request({
    url: `bookDetail/list`,
    method: 'post',
    data
  })
}
export function detailEdits2 (data) {
  return request({
    url: `bookDetail/list2`,
    method: 'post',
    data
  })
}
export function detailInfo (id) {
  return request({
    url: `bookDetail/getDetail/${id}`,
    method: 'get'
  })
}

export function delDetail (id) {
  return request({
    url: `bookDetail/list/${id}`,
    method: 'delete'
  })
}

export function exportData (data) {
  return request({
    url: `book/exportInfos`,
    method: 'post',
    data
  })
}
